import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as fonts from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'esp-icon',
  templateUrl: './icon.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule],
  styleUrls: ['./icon.component.scss']
})

export class IconComponent {
  @Input() icon:string = "";
  public fonts:any = {
  fa0 : fonts.fa0,
  fa1 : fonts.fa1,
  fa2 : fonts.fa2,
  fa3 : fonts.fa3,
  fa4 : fonts.fa4,
  fa5 : fonts.fa5,
  fa6 : fonts.fa6,
  fa7 : fonts.fa7,
  fa8 : fonts.fa8,
  fa9 : fonts.fa9,
  faFillDrip : fonts.faFillDrip,
  faArrowsToCircle : fonts.faArrowsToCircle,
  faCircleChevronRight : fonts.faCircleChevronRight,
  faChevronCircleRight : fonts.faChevronCircleRight,
  faAt : fonts.faAt,
  faTrashCan : fonts.faTrashCan,
  faTrashAlt : fonts.faTrashAlt,
  faTextHeight : fonts.faTextHeight,
  faUserXmark : fonts.faUserXmark,
  faUserTimes : fonts.faUserTimes,
  faStethoscope : fonts.faStethoscope,
  faMessage : fonts.faMessage,
  faCommentAlt : fonts.faCommentAlt,
  faInfo : fonts.faInfo,
  faDownLeftAndUpRightToCenter : fonts.faDownLeftAndUpRightToCenter,
  faCompressAlt : fonts.faCompressAlt,
  faExplosion : fonts.faExplosion,
  faFileLines : fonts.faFileLines,
  faFileAlt : fonts.faFileAlt,
  faFileText : fonts.faFileText,
  faWaveSquare : fonts.faWaveSquare,
  faRing : fonts.faRing,
  faBuildingUn : fonts.faBuildingUn,
  faDiceThree : fonts.faDiceThree,
  faCalendarDays : fonts.faCalendarDays,
  faCalendarAlt : fonts.faCalendarAlt,
  faAnchorCircleCheck : fonts.faAnchorCircleCheck,
  faBuildingCircleArrowRight : fonts.faBuildingCircleArrowRight,
  faVolleyball : fonts.faVolleyball,
  faVolleyballBall : fonts.faVolleyballBall,
  faArrowsUpToLine : fonts.faArrowsUpToLine,
  faSortDown : fonts.faSortDown,
  faSortDesc : fonts.faSortDesc,
  faCircleMinus : fonts.faCircleMinus,
  faMinusCircle : fonts.faMinusCircle,
  faDoorOpen : fonts.faDoorOpen,
  faRightFromBracket : fonts.faRightFromBracket,
  faSignOutAlt : fonts.faSignOutAlt,
  faAtom : fonts.faAtom,
  faSoap : fonts.faSoap,
  faIcons : fonts.faIcons,
  faHeartMusicCameraBolt : fonts.faHeartMusicCameraBolt,
  faMicrophoneLinesSlash : fonts.faMicrophoneLinesSlash,
  faMicrophoneAltSlash : fonts.faMicrophoneAltSlash,
  faBridgeCircleCheck : fonts.faBridgeCircleCheck,
  faPumpMedical : fonts.faPumpMedical,
  faFingerprint : fonts.faFingerprint,
  faHandPointRight : fonts.faHandPointRight,
  faMagnifyingGlassLocation : fonts.faMagnifyingGlassLocation,
  faSearchLocation : fonts.faSearchLocation,
  faForwardStep : fonts.faForwardStep,
  faStepForward : fonts.faStepForward,
  faFaceSmileBeam : fonts.faFaceSmileBeam,
  faSmileBeam : fonts.faSmileBeam,
  faFlagCheckered : fonts.faFlagCheckered,
  faFootball : fonts.faFootball,
  faFootballBall : fonts.faFootballBall,
  faSchoolCircleExclamation : fonts.faSchoolCircleExclamation,
  faCrop : fonts.faCrop,
  faAnglesDown : fonts.faAnglesDown,
  faAngleDoubleDown : fonts.faAngleDoubleDown,
  faUsersRectangle : fonts.faUsersRectangle,
  faPeopleRoof : fonts.faPeopleRoof,
  faPeopleLine : fonts.faPeopleLine,
  faBeerMugEmpty : fonts.faBeerMugEmpty,
  faBeer : fonts.faBeer,
  faDiagramPredecessor : fonts.faDiagramPredecessor,
  faArrowUpLong : fonts.faArrowUpLong,
  faLongArrowUp : fonts.faLongArrowUp,
  faFireFlameSimple : fonts.faFireFlameSimple,
  faBurn : fonts.faBurn,
  faPerson : fonts.faPerson,
  faMale : fonts.faMale,
  faLaptop : fonts.faLaptop,
  faFileCsv : fonts.faFileCsv,
  faMenorah : fonts.faMenorah,
  faTruckPlane : fonts.faTruckPlane,
  faRecordVinyl : fonts.faRecordVinyl,
  faFaceGrinStars : fonts.faFaceGrinStars,
  faGrinStars : fonts.faGrinStars,
  faBong : fonts.faBong,
  faSpaghettiMonsterFlying : fonts.faSpaghettiMonsterFlying,
  faPastafarianism : fonts.faPastafarianism,
  faArrowDownUpAcrossLine : fonts.faArrowDownUpAcrossLine,
  faSpoon : fonts.faSpoon,
  faUtensilSpoon : fonts.faUtensilSpoon,
  faJarWheat : fonts.faJarWheat,
  faEnvelopesBulk : fonts.faEnvelopesBulk,
  faMailBulk : fonts.faMailBulk,
  faFileCircleExclamation : fonts.faFileCircleExclamation,
  faCircleH : fonts.faCircleH,
  faHospitalSymbol : fonts.faHospitalSymbol,
  faPager : fonts.faPager,
  faAddressBook : fonts.faAddressBook,
  faContactBook : fonts.faContactBook,
  faStrikethrough : fonts.faStrikethrough,
  faK : fonts.faK,
  faLandmarkFlag : fonts.faLandmarkFlag,
  faPencil : fonts.faPencil,
  faPencilAlt : fonts.faPencilAlt,
  faBackward : fonts.faBackward,
  faCaretRight : fonts.faCaretRight,
  faComments : fonts.faComments,
  faPaste : fonts.faPaste,
  faFileClipboard : fonts.faFileClipboard,
  faCodePullRequest : fonts.faCodePullRequest,
  faClipboardList : fonts.faClipboardList,
  faTruckRampBox : fonts.faTruckRampBox,
  faTruckLoading : fonts.faTruckLoading,
  faUserCheck : fonts.faUserCheck,
  faVialVirus : fonts.faVialVirus,
  faSheetPlastic : fonts.faSheetPlastic,
  faBlog : fonts.faBlog,
  faUserNinja : fonts.faUserNinja,
  faPersonArrowUpFromLine : fonts.faPersonArrowUpFromLine,
  faScrollTorah : fonts.faScrollTorah,
  faTorah : fonts.faTorah,
  faBroomBall : fonts.faBroomBall,
  faQuidditch : fonts.faQuidditch,
  faQuidditchBroomBall : fonts.faQuidditchBroomBall,
  faToggleOff : fonts.faToggleOff,
  faBoxArchive : fonts.faBoxArchive,
  faArchive : fonts.faArchive,
  faPersonDrowning : fonts.faPersonDrowning,
  faArrowDown91 : fonts.faArrowDown91,
  faSortNumericDesc : fonts.faSortNumericDesc,
  faSortNumericDownAlt : fonts.faSortNumericDownAlt,
  faFaceGrinTongueSquint : fonts.faFaceGrinTongueSquint,
  faGrinTongueSquint : fonts.faGrinTongueSquint,
  faSprayCan : fonts.faSprayCan,
  faTruckMonster : fonts.faTruckMonster,
  faW : fonts.faW,
  faEarthAfrica : fonts.faEarthAfrica,
  faGlobeAfrica : fonts.faGlobeAfrica,
  faRainbow : fonts.faRainbow,
  faCircleNotch : fonts.faCircleNotch,
  faTabletScreenButton : fonts.faTabletScreenButton,
  faTabletAlt : fonts.faTabletAlt,
  faPaw : fonts.faPaw,
  faCloud : fonts.faCloud,
  faTrowelBricks : fonts.faTrowelBricks,
  faFaceFlushed : fonts.faFaceFlushed,
  faFlushed : fonts.faFlushed,
  faHospitalUser : fonts.faHospitalUser,
  faTentArrowLeftRight : fonts.faTentArrowLeftRight,
  faGavel : fonts.faGavel,
  faLegal : fonts.faLegal,
  faBinoculars : fonts.faBinoculars,
  faMicrophoneSlash : fonts.faMicrophoneSlash,
  faBoxTissue : fonts.faBoxTissue,
  faMotorcycle : fonts.faMotorcycle,
  faBellConcierge : fonts.faBellConcierge,
  faConciergeBell : fonts.faConciergeBell,
  faPenRuler : fonts.faPenRuler,
  faPencilRuler : fonts.faPencilRuler,
  faPeopleArrows : fonts.faPeopleArrows,
  faPeopleArrowsLeftRight : fonts.faPeopleArrowsLeftRight,
  faMarsAndVenusBurst : fonts.faMarsAndVenusBurst,
  faSquareCaretRight : fonts.faSquareCaretRight,
  faCaretSquareRight : fonts.faCaretSquareRight,
  faScissors : fonts.faScissors,
  faCut : fonts.faCut,
  faSunPlantWilt : fonts.faSunPlantWilt,
  faToiletsPortable : fonts.faToiletsPortable,
  faHockeyPuck : fonts.faHockeyPuck,
  faTable : fonts.faTable,
  faMagnifyingGlassArrowRight : fonts.faMagnifyingGlassArrowRight,
  faTachographDigital : fonts.faTachographDigital,
  faDigitalTachograph : fonts.faDigitalTachograph,
  faUsersSlash : fonts.faUsersSlash,
  faClover : fonts.faClover,
  faReply : fonts.faReply,
  faMailReply : fonts.faMailReply,
  faStarAndCrescent : fonts.faStarAndCrescent,
  faHouseFire : fonts.faHouseFire,
  faSquareMinus : fonts.faSquareMinus,
  faMinusSquare : fonts.faMinusSquare,
  faHelicopter : fonts.faHelicopter,
  faCompass : fonts.faCompass,
  faSquareCaretDown : fonts.faSquareCaretDown,
  faCaretSquareDown : fonts.faCaretSquareDown,
  faFileCircleQuestion : fonts.faFileCircleQuestion,
  faLaptopCode : fonts.faLaptopCode,
  faSwatchbook : fonts.faSwatchbook,
  faPrescriptionBottle : fonts.faPrescriptionBottle,
  faBars : fonts.faBars,
  faNavicon : fonts.faNavicon,
  faPeopleGroup : fonts.faPeopleGroup,
  faHourglassEnd : fonts.faHourglassEnd,
  faHourglass3 : fonts.faHourglass3,
  faHeartCrack : fonts.faHeartCrack,
  faHeartBroken : fonts.faHeartBroken,
  faSquareUpRight : fonts.faSquareUpRight,
  faExternalLinkSquareAlt : fonts.faExternalLinkSquareAlt,
  faFaceKissBeam : fonts.faFaceKissBeam,
  faKissBeam : fonts.faKissBeam,
  faFilm : fonts.faFilm,
  faRulerHorizontal : fonts.faRulerHorizontal,
  faPeopleRobbery : fonts.faPeopleRobbery,
  faLightbulb : fonts.faLightbulb,
  faCaretLeft : fonts.faCaretLeft,
  faCircleExclamation : fonts.faCircleExclamation,
  faExclamationCircle : fonts.faExclamationCircle,
  faSchoolCircleXmark : fonts.faSchoolCircleXmark,
  faArrowRightFromBracket : fonts.faArrowRightFromBracket,
  faSignOut : fonts.faSignOut,
  faCircleChevronDown : fonts.faCircleChevronDown,
  faChevronCircleDown : fonts.faChevronCircleDown,
  faUnlockKeyhole : fonts.faUnlockKeyhole,
  faUnlockAlt : fonts.faUnlockAlt,
  faCloudShowersHeavy : fonts.faCloudShowersHeavy,
  faHeadphonesSimple : fonts.faHeadphonesSimple,
  faHeadphonesAlt : fonts.faHeadphonesAlt,
  faSitemap : fonts.faSitemap,
  faCircleDollarToSlot : fonts.faCircleDollarToSlot,
  faDonate : fonts.faDonate,
  faMemory : fonts.faMemory,
  faRoadSpikes : fonts.faRoadSpikes,
  faFireBurner : fonts.faFireBurner,
  faFlag : fonts.faFlag,
  faHanukiah : fonts.faHanukiah,
  faFeather : fonts.faFeather,
  faVolumeLow : fonts.faVolumeLow,
  faVolumeDown : fonts.faVolumeDown,
  faCommentSlash : fonts.faCommentSlash,
  faCloudSunRain : fonts.faCloudSunRain,
  faCompress : fonts.faCompress,
  faWheatAwn : fonts.faWheatAwn,
  faWheatAlt : fonts.faWheatAlt,
  faAnkh : fonts.faAnkh,
  faHandsHoldingChild : fonts.faHandsHoldingChild,
  faAsterisk : fonts.faAsterisk,
  faSquareCheck : fonts.faSquareCheck,
  faCheckSquare : fonts.faCheckSquare,
  faPesetaSign : fonts.faPesetaSign,
  faHeading : fonts.faHeading,
  faHeader : fonts.faHeader,
  faGhost : fonts.faGhost,
  faList : fonts.faList,
  faListSquares : fonts.faListSquares,
  faSquarePhoneFlip : fonts.faSquarePhoneFlip,
  faPhoneSquareAlt : fonts.faPhoneSquareAlt,
  faCartPlus : fonts.faCartPlus,
  faGamepad : fonts.faGamepad,
  faCircleDot : fonts.faCircleDot,
  faDotCircle : fonts.faDotCircle,
  faFaceDizzy : fonts.faFaceDizzy,
  faDizzy : fonts.faDizzy,
  faEgg : fonts.faEgg,
  faHouseMedicalCircleXmark : fonts.faHouseMedicalCircleXmark,
  faCampground : fonts.faCampground,
  faFolderPlus : fonts.faFolderPlus,
  faFutbol : fonts.faFutbol,
  faFutbolBall : fonts.faFutbolBall,
  faSoccerBall : fonts.faSoccerBall,
  faPaintbrush : fonts.faPaintbrush,
  faPaintBrush : fonts.faPaintBrush,
  faLock : fonts.faLock,
  faGasPump : fonts.faGasPump,
  faHotTubPerson : fonts.faHotTubPerson,
  faHotTub : fonts.faHotTub,
  faMapLocation : fonts.faMapLocation,
  faMapMarked : fonts.faMapMarked,
  faHouseFloodWater : fonts.faHouseFloodWater,
  faTree : fonts.faTree,
  faBridgeLock : fonts.faBridgeLock,
  faSackDollar : fonts.faSackDollar,
  faPenToSquare : fonts.faPenToSquare,
  faEdit : fonts.faEdit,
  faCarSide : fonts.faCarSide,
  faShareNodes : fonts.faShareNodes,
  faShareAlt : fonts.faShareAlt,
  faHeartCircleMinus : fonts.faHeartCircleMinus,
  faHourglassHalf : fonts.faHourglassHalf,
  faHourglass2 : fonts.faHourglass2,
  faMicroscope : fonts.faMicroscope,
  faSink : fonts.faSink,
  faBagShopping : fonts.faBagShopping,
  faShoppingBag : fonts.faShoppingBag,
  faArrowDownZA : fonts.faArrowDownZA,
  faSortAlphaDesc : fonts.faSortAlphaDesc,
  faSortAlphaDownAlt : fonts.faSortAlphaDownAlt,
  faMitten : fonts.faMitten,
  faPersonRays : fonts.faPersonRays,
  faUsers : fonts.faUsers,
  faEyeSlash : fonts.faEyeSlash,
  faFlaskVial : fonts.faFlaskVial,
  faHand : fonts.faHand,
  faHandPaper : fonts.faHandPaper,
  faOm : fonts.faOm,
  faWorm : fonts.faWorm,
  faHouseCircleXmark : fonts.faHouseCircleXmark,
  faPlug : fonts.faPlug,
  faChevronUp : fonts.faChevronUp,
  faHandSpock : fonts.faHandSpock,
  faStopwatch : fonts.faStopwatch,
  faFaceKiss : fonts.faFaceKiss,
  faKiss : fonts.faKiss,
  faBridgeCircleXmark : fonts.faBridgeCircleXmark,
  faFaceGrinTongue : fonts.faFaceGrinTongue,
  faGrinTongue : fonts.faGrinTongue,
  faChessBishop : fonts.faChessBishop,
  faFaceGrinWink : fonts.faFaceGrinWink,
  faGrinWink : fonts.faGrinWink,
  faEarDeaf : fonts.faEarDeaf,
  faDeaf : fonts.faDeaf,
  faDeafness : fonts.faDeafness,
  faHardOfHearing : fonts.faHardOfHearing,
  faRoadCircleCheck : fonts.faRoadCircleCheck,
  faDiceFive : fonts.faDiceFive,
  faSquareRss : fonts.faSquareRss,
  faRssSquare : fonts.faRssSquare,
  faLandMineOn : fonts.faLandMineOn,
  faICursor : fonts.faICursor,
  faStamp : fonts.faStamp,
  faStairs : fonts.faStairs,
  faI : fonts.faI,
  faHryvniaSign : fonts.faHryvniaSign,
  faHryvnia : fonts.faHryvnia,
  faPills : fonts.faPills,
  faFaceGrinWide : fonts.faFaceGrinWide,
  faGrinAlt : fonts.faGrinAlt,
  faTooth : fonts.faTooth,
  faV : fonts.faV,
  faBangladeshiTakaSign : fonts.faBangladeshiTakaSign,
  faBicycle : fonts.faBicycle,
  faStaffSnake : fonts.faStaffSnake,
  faRodAsclepius : fonts.faRodAsclepius,
  faRodSnake : fonts.faRodSnake,
  faStaffAesculapius : fonts.faStaffAesculapius,
  faHeadSideCoughSlash : fonts.faHeadSideCoughSlash,
  faTruckMedical : fonts.faTruckMedical,
  faAmbulance : fonts.faAmbulance,
  faWheatAwnCircleExclamation : fonts.faWheatAwnCircleExclamation,
  faSnowman : fonts.faSnowman,
  faMortarPestle : fonts.faMortarPestle,
  faRoadBarrier : fonts.faRoadBarrier,
  faSchool : fonts.faSchool,
  faIgloo : fonts.faIgloo,
  faJoint : fonts.faJoint,
  faAngleRight : fonts.faAngleRight,
  faHorse : fonts.faHorse,
  faQ : fonts.faQ,
  faG : fonts.faG,
  faNotesMedical : fonts.faNotesMedical,
  faTemperatureHalf : fonts.faTemperatureHalf,
  faTemperature2 : fonts.faTemperature2,
  faThermometer2 : fonts.faThermometer2,
  faThermometerHalf : fonts.faThermometerHalf,
  faDongSign : fonts.faDongSign,
  faCapsules : fonts.faCapsules,
  faPooStorm : fonts.faPooStorm,
  faPooBolt : fonts.faPooBolt,
  faFaceFrownOpen : fonts.faFaceFrownOpen,
  faFrownOpen : fonts.faFrownOpen,
  faHandPointUp : fonts.faHandPointUp,
  faMoneyBill : fonts.faMoneyBill,
  faBookmark : fonts.faBookmark,
  faAlignJustify : fonts.faAlignJustify,
  faUmbrellaBeach : fonts.faUmbrellaBeach,
  faHelmetUn : fonts.faHelmetUn,
  faBullseye : fonts.faBullseye,
  faBacon : fonts.faBacon,
  faHandPointDown : fonts.faHandPointDown,
  faArrowUpFromBracket : fonts.faArrowUpFromBracket,
  faFolder : fonts.faFolder,
  faFolderBlank : fonts.faFolderBlank,
  faFileWaveform : fonts.faFileWaveform,
  faFileMedicalAlt : fonts.faFileMedicalAlt,
  faRadiation : fonts.faRadiation,
  faChartSimple : fonts.faChartSimple,
  faMarsStroke : fonts.faMarsStroke,
  faVial : fonts.faVial,
  faGauge : fonts.faGauge,
  faDashboard : fonts.faDashboard,
  faGaugeMed : fonts.faGaugeMed,
  faTachometerAltAverage : fonts.faTachometerAltAverage,
  faWandMagicSparkles : fonts.faWandMagicSparkles,
  faMagicWandSparkles : fonts.faMagicWandSparkles,
  faE : fonts.faE,
  faPenClip : fonts.faPenClip,
  faPenAlt : fonts.faPenAlt,
  faBridgeCircleExclamation : fonts.faBridgeCircleExclamation,
  faUser : fonts.faUser,
  faSchoolCircleCheck : fonts.faSchoolCircleCheck,
  faDumpster : fonts.faDumpster,
  faVanShuttle : fonts.faVanShuttle,
  faShuttleVan : fonts.faShuttleVan,
  faBuildingUser : fonts.faBuildingUser,
  faSquareCaretLeft : fonts.faSquareCaretLeft,
  faCaretSquareLeft : fonts.faCaretSquareLeft,
  faHighlighter : fonts.faHighlighter,
  faKey : fonts.faKey,
  faBullhorn : fonts.faBullhorn,
  faGlobe : fonts.faGlobe,
  faSynagogue : fonts.faSynagogue,
  faPersonHalfDress : fonts.faPersonHalfDress,
  faRoadBridge : fonts.faRoadBridge,
  faLocationArrow : fonts.faLocationArrow,
  faC : fonts.faC,
  faTabletButton : fonts.faTabletButton,
  faBuildingLock : fonts.faBuildingLock,
  faPizzaSlice : fonts.faPizzaSlice,
  faMoneyBillWave : fonts.faMoneyBillWave,
  faChartArea : fonts.faChartArea,
  faAreaChart : fonts.faAreaChart,
  faHouseFlag : fonts.faHouseFlag,
  faPersonCircleMinus : fonts.faPersonCircleMinus,
  faBan : fonts.faBan,
  faCancel : fonts.faCancel,
  faCameraRotate : fonts.faCameraRotate,
  faSprayCanSparkles : fonts.faSprayCanSparkles,
  faAirFreshener : fonts.faAirFreshener,
  faStar : fonts.faStar,
  faRepeat : fonts.faRepeat,
  faCross : fonts.faCross,
  faBox : fonts.faBox,
  faVenusMars : fonts.faVenusMars,
  faArrowPointer : fonts.faArrowPointer,
  faMousePointer : fonts.faMousePointer,
  faMaximize : fonts.faMaximize,
  faExpandArrowsAlt : fonts.faExpandArrowsAlt,
  faChargingStation : fonts.faChargingStation,
  faShapes : fonts.faShapes,
  faTriangleCircleSquare : fonts.faTriangleCircleSquare,
  faShuffle : fonts.faShuffle,
  faRandom : fonts.faRandom,
  faPersonRunning : fonts.faPersonRunning,
  faRunning : fonts.faRunning,
  faMobileRetro : fonts.faMobileRetro,
  faGripLinesVertical : fonts.faGripLinesVertical,
  faSpider : fonts.faSpider,
  faHandsBound : fonts.faHandsBound,
  faFileInvoiceDollar : fonts.faFileInvoiceDollar,
  faPlaneCircleExclamation : fonts.faPlaneCircleExclamation,
  faXRay : fonts.faXRay,
  faSpellCheck : fonts.faSpellCheck,
  faSlash : fonts.faSlash,
  faComputerMouse : fonts.faComputerMouse,
  faMouse : fonts.faMouse,
  faArrowRightToBracket : fonts.faArrowRightToBracket,
  faSignIn : fonts.faSignIn,
  faShopSlash : fonts.faShopSlash,
  faStoreAltSlash : fonts.faStoreAltSlash,
  faServer : fonts.faServer,
  faVirusCovidSlash : fonts.faVirusCovidSlash,
  faShopLock : fonts.faShopLock,
  faHourglassStart : fonts.faHourglassStart,
  faHourglass1 : fonts.faHourglass1,
  faBlenderPhone : fonts.faBlenderPhone,
  faBuildingWheat : fonts.faBuildingWheat,
  faPersonBreastfeeding : fonts.faPersonBreastfeeding,
  faRightToBracket : fonts.faRightToBracket,
  faSignInAlt : fonts.faSignInAlt,
  faVenus : fonts.faVenus,
  faPassport : fonts.faPassport,
  faHeartPulse : fonts.faHeartPulse,
  faHeartbeat : fonts.faHeartbeat,
  faPeopleCarryBox : fonts.faPeopleCarryBox,
  faPeopleCarry : fonts.faPeopleCarry,
  faTemperatureHigh : fonts.faTemperatureHigh,
  faMicrochip : fonts.faMicrochip,
  faCrown : fonts.faCrown,
  faWeightHanging : fonts.faWeightHanging,
  faXmarksLines : fonts.faXmarksLines,
  faFilePrescription : fonts.faFilePrescription,
  faWeightScale : fonts.faWeightScale,
  faWeight : fonts.faWeight,
  faUserGroup : fonts.faUserGroup,
  faUserFriends : fonts.faUserFriends,
  faArrowUpAZ : fonts.faArrowUpAZ,
  faSortAlphaUp : fonts.faSortAlphaUp,
  faChessKnight : fonts.faChessKnight,
  faFaceLaughSquint : fonts.faFaceLaughSquint,
  faLaughSquint : fonts.faLaughSquint,
  faWheelchair : fonts.faWheelchair,
  faCircleArrowUp : fonts.faCircleArrowUp,
  faArrowCircleUp : fonts.faArrowCircleUp,
  faToggleOn : fonts.faToggleOn,
  faPersonWalking : fonts.faPersonWalking,
  faWalking : fonts.faWalking,
  faL : fonts.faL,
  faFire : fonts.faFire,
  faBedPulse : fonts.faBedPulse,
  faProcedures : fonts.faProcedures,
  faShuttleSpace : fonts.faShuttleSpace,
  faSpaceShuttle : fonts.faSpaceShuttle,
  faFaceLaugh : fonts.faFaceLaugh,
  faLaugh : fonts.faLaugh,
  faFolderOpen : fonts.faFolderOpen,
  faHeartCirclePlus : fonts.faHeartCirclePlus,
  faCodeFork : fonts.faCodeFork,
  faCity : fonts.faCity,
  faMicrophoneLines : fonts.faMicrophoneLines,
  faMicrophoneAlt : fonts.faMicrophoneAlt,
  faPepperHot : fonts.faPepperHot,
  faUnlock : fonts.faUnlock,
  faColonSign : fonts.faColonSign,
  faHeadset : fonts.faHeadset,
  faStoreSlash : fonts.faStoreSlash,
  faRoadCircleXmark : fonts.faRoadCircleXmark,
  faUserMinus : fonts.faUserMinus,
  faMarsStrokeUp : fonts.faMarsStrokeUp,
  faMarsStrokeV : fonts.faMarsStrokeV,
  faChampagneGlasses : fonts.faChampagneGlasses,
  faGlassCheers : fonts.faGlassCheers,
  faClipboard : fonts.faClipboard,
  faHouseCircleExclamation : fonts.faHouseCircleExclamation,
  faFileArrowUp : fonts.faFileArrowUp,
  faFileUpload : fonts.faFileUpload,
  faWifi : fonts.faWifi,
  faWifi3 : fonts.faWifi3,
  faWifiStrong : fonts.faWifiStrong,
  faBath : fonts.faBath,
  faBathtub : fonts.faBathtub,
  faUnderline : fonts.faUnderline,
  faUserPen : fonts.faUserPen,
  faUserEdit : fonts.faUserEdit,
  faSignature : fonts.faSignature,
  faStroopwafel : fonts.faStroopwafel,
  faBold : fonts.faBold,
  faAnchorLock : fonts.faAnchorLock,
  faBuildingNgo : fonts.faBuildingNgo,
  faManatSign : fonts.faManatSign,
  faNotEqual : fonts.faNotEqual,
  faBorderTopLeft : fonts.faBorderTopLeft,
  faBorderStyle : fonts.faBorderStyle,
  faMapLocationDot : fonts.faMapLocationDot,
  faMapMarkedAlt : fonts.faMapMarkedAlt,
  faJedi : fonts.faJedi,
  faSquarePollVertical : fonts.faSquarePollVertical,
  faPoll : fonts.faPoll,
  faMugHot : fonts.faMugHot,
  faCarBattery : fonts.faCarBattery,
  faBatteryCar : fonts.faBatteryCar,
  faGift : fonts.faGift,
  faDiceTwo : fonts.faDiceTwo,
  faChessQueen : fonts.faChessQueen,
  faGlasses : fonts.faGlasses,
  faChessBoard : fonts.faChessBoard,
  faBuildingCircleCheck : fonts.faBuildingCircleCheck,
  faPersonChalkboard : fonts.faPersonChalkboard,
  faMarsStrokeRight : fonts.faMarsStrokeRight,
  faMarsStrokeH : fonts.faMarsStrokeH,
  faHandBackFist : fonts.faHandBackFist,
  faHandRock : fonts.faHandRock,
  faSquareCaretUp : fonts.faSquareCaretUp,
  faCaretSquareUp : fonts.faCaretSquareUp,
  faCloudShowersWater : fonts.faCloudShowersWater,
  faChartBar : fonts.faChartBar,
  faBarChart : fonts.faBarChart,
  faHandsBubbles : fonts.faHandsBubbles,
  faHandsWash : fonts.faHandsWash,
  faLessThanEqual : fonts.faLessThanEqual,
  faTrain : fonts.faTrain,
  faEyeLowVision : fonts.faEyeLowVision,
  faLowVision : fonts.faLowVision,
  faCrow : fonts.faCrow,
  faSailboat : fonts.faSailboat,
  faWindowRestore : fonts.faWindowRestore,
  faSquarePlus : fonts.faSquarePlus,
  faPlusSquare : fonts.faPlusSquare,
  faToriiGate : fonts.faToriiGate,
  faFrog : fonts.faFrog,
  faBucket : fonts.faBucket,
  faImage : fonts.faImage,
  faMicrophone : fonts.faMicrophone,
  faCow : fonts.faCow,
  faCaretUp : fonts.faCaretUp,
  faScrewdriver : fonts.faScrewdriver,
  faFolderClosed : fonts.faFolderClosed,
  faHouseTsunami : fonts.faHouseTsunami,
  faSquareNfi : fonts.faSquareNfi,
  faArrowUpFromGroundWater : fonts.faArrowUpFromGroundWater,
  faMartiniGlass : fonts.faMartiniGlass,
  faGlassMartiniAlt : fonts.faGlassMartiniAlt,
  faRotateLeft : fonts.faRotateLeft,
  faRotateBack : fonts.faRotateBack,
  faRotateBackward : fonts.faRotateBackward,
  faUndoAlt : fonts.faUndoAlt,
  faTableColumns : fonts.faTableColumns,
  faColumns : fonts.faColumns,
  faLemon : fonts.faLemon,
  faHeadSideMask : fonts.faHeadSideMask,
  faHandshake : fonts.faHandshake,
  faGem : fonts.faGem,
  faDolly : fonts.faDolly,
  faDollyBox : fonts.faDollyBox,
  faSmoking : fonts.faSmoking,
  faMinimize : fonts.faMinimize,
  faCompressArrowsAlt : fonts.faCompressArrowsAlt,
  faMonument : fonts.faMonument,
  faSnowplow : fonts.faSnowplow,
  faAnglesRight : fonts.faAnglesRight,
  faAngleDoubleRight : fonts.faAngleDoubleRight,
  faCannabis : fonts.faCannabis,
  faCirclePlay : fonts.faCirclePlay,
  faPlayCircle : fonts.faPlayCircle,
  faTablets : fonts.faTablets,
  faEthernet : fonts.faEthernet,
  faEuroSign : fonts.faEuroSign,
  faEur : fonts.faEur,
  faEuro : fonts.faEuro,
  faChair : fonts.faChair,
  faCircleCheck : fonts.faCircleCheck,
  faCheckCircle : fonts.faCheckCircle,
  faCircleStop : fonts.faCircleStop,
  faStopCircle : fonts.faStopCircle,
  faCompassDrafting : fonts.faCompassDrafting,
  faDraftingCompass : fonts.faDraftingCompass,
  faPlateWheat : fonts.faPlateWheat,
  faIcicles : fonts.faIcicles,
  faPersonShelter : fonts.faPersonShelter,
  faNeuter : fonts.faNeuter,
  faIdBadge : fonts.faIdBadge,
  faMarker : fonts.faMarker,
  faFaceLaughBeam : fonts.faFaceLaughBeam,
  faLaughBeam : fonts.faLaughBeam,
  faHelicopterSymbol : fonts.faHelicopterSymbol,
  faUniversalAccess : fonts.faUniversalAccess,
  faCircleChevronUp : fonts.faCircleChevronUp,
  faChevronCircleUp : fonts.faChevronCircleUp,
  faLariSign : fonts.faLariSign,
  faVolcano : fonts.faVolcano,
  faPersonWalkingDashedLineArrowRight : fonts.faPersonWalkingDashedLineArrowRight,
  faSterlingSign : fonts.faSterlingSign,
  faGbp : fonts.faGbp,
  faPoundSign : fonts.faPoundSign,
  faViruses : fonts.faViruses,
  faSquarePersonConfined : fonts.faSquarePersonConfined,
  faUserTie : fonts.faUserTie,
  faArrowDownLong : fonts.faArrowDownLong,
  faLongArrowDown : fonts.faLongArrowDown,
  faTentArrowDownToLine : fonts.faTentArrowDownToLine,
  faCertificate : fonts.faCertificate,
  faReplyAll : fonts.faReplyAll,
  faMailReplyAll : fonts.faMailReplyAll,
  faSuitcase : fonts.faSuitcase,
  faPersonSkating : fonts.faPersonSkating,
  faSkating : fonts.faSkating,
  faFilterCircleDollar : fonts.faFilterCircleDollar,
  faFunnelDollar : fonts.faFunnelDollar,
  faCameraRetro : fonts.faCameraRetro,
  faCircleArrowDown : fonts.faCircleArrowDown,
  faArrowCircleDown : fonts.faArrowCircleDown,
  faFileImport : fonts.faFileImport,
  faArrowRightToFile : fonts.faArrowRightToFile,
  faSquareArrowUpRight : fonts.faSquareArrowUpRight,
  faExternalLinkSquare : fonts.faExternalLinkSquare,
  faBoxOpen : fonts.faBoxOpen,
  faScroll : fonts.faScroll,
  faSpa : fonts.faSpa,
  faLocationPinLock : fonts.faLocationPinLock,
  faPause : fonts.faPause,
  faHillAvalanche : fonts.faHillAvalanche,
  faTemperatureEmpty : fonts.faTemperatureEmpty,
  faTemperature0 : fonts.faTemperature0,
  faThermometer0 : fonts.faThermometer0,
  faThermometerEmpty : fonts.faThermometerEmpty,
  faBomb : fonts.faBomb,
  faRegistered : fonts.faRegistered,
  faAddressCard : fonts.faAddressCard,
  faContactCard : fonts.faContactCard,
  faVcard : fonts.faVcard,
  faScaleUnbalancedFlip : fonts.faScaleUnbalancedFlip,
  faBalanceScaleRight : fonts.faBalanceScaleRight,
  faSubscript : fonts.faSubscript,
  faDiamondTurnRight : fonts.faDiamondTurnRight,
  faDirections : fonts.faDirections,
  faBurst : fonts.faBurst,
  faHouseLaptop : fonts.faHouseLaptop,
  faLaptopHouse : fonts.faLaptopHouse,
  faFaceTired : fonts.faFaceTired,
  faTired : fonts.faTired,
  faMoneyBills : fonts.faMoneyBills,
  faSmog : fonts.faSmog,
  faCrutch : fonts.faCrutch,
  faFontAwesome : fonts.faFontAwesome,
  faFontAwesomeFlag : fonts.faFontAwesomeFlag,
  faFontAwesomeLogoFull : fonts.faFontAwesomeLogoFull,
  faCloudArrowUp : fonts.faCloudArrowUp,
  faCloudUpload : fonts.faCloudUpload,
  faCloudUploadAlt : fonts.faCloudUploadAlt,
  faPalette : fonts.faPalette,
  faArrowsTurnRight : fonts.faArrowsTurnRight,
  faVest : fonts.faVest,
  faFerry : fonts.faFerry,
  faArrowsDownToPeople : fonts.faArrowsDownToPeople,
  faSeedling : fonts.faSeedling,
  faSprout : fonts.faSprout,
  faLeftRight : fonts.faLeftRight,
  faArrowsAltH : fonts.faArrowsAltH,
  faBoxesPacking : fonts.faBoxesPacking,
  faCircleArrowLeft : fonts.faCircleArrowLeft,
  faArrowCircleLeft : fonts.faArrowCircleLeft,
  faGroupArrowsRotate : fonts.faGroupArrowsRotate,
  faBowlFood : fonts.faBowlFood,
  faCandyCane : fonts.faCandyCane,
  faArrowDownWideShort : fonts.faArrowDownWideShort,
  faSortAmountAsc : fonts.faSortAmountAsc,
  faSortAmountDown : fonts.faSortAmountDown,
  faCloudBolt : fonts.faCloudBolt,
  faThunderstorm : fonts.faThunderstorm,
  faTextSlash : fonts.faTextSlash,
  faRemoveFormat : fonts.faRemoveFormat,
  faFaceSmileWink : fonts.faFaceSmileWink,
  faSmileWink : fonts.faSmileWink,
  faFileWord : fonts.faFileWord,
  faFilePowerpoint : fonts.faFilePowerpoint,
  faArrowsLeftRight : fonts.faArrowsLeftRight,
  faArrowsH : fonts.faArrowsH,
  faHouseLock : fonts.faHouseLock,
  faCloudArrowDown : fonts.faCloudArrowDown,
  faCloudDownload : fonts.faCloudDownload,
  faCloudDownloadAlt : fonts.faCloudDownloadAlt,
  faChildren : fonts.faChildren,
  faChalkboard : fonts.faChalkboard,
  faBlackboard : fonts.faBlackboard,
  faUserLargeSlash : fonts.faUserLargeSlash,
  faUserAltSlash : fonts.faUserAltSlash,
  faEnvelopeOpen : fonts.faEnvelopeOpen,
  faHandshakeSimpleSlash : fonts.faHandshakeSimpleSlash,
  faHandshakeAltSlash : fonts.faHandshakeAltSlash,
  faMattressPillow : fonts.faMattressPillow,
  faGuaraniSign : fonts.faGuaraniSign,
  faArrowsRotate : fonts.faArrowsRotate,
  faRefresh : fonts.faRefresh,
  faSync : fonts.faSync,
  faFireExtinguisher : fonts.faFireExtinguisher,
  faCruzeiroSign : fonts.faCruzeiroSign,
  faGreaterThanEqual : fonts.faGreaterThanEqual,
  faShieldHalved : fonts.faShieldHalved,
  faShieldAlt : fonts.faShieldAlt,
  faBookAtlas : fonts.faBookAtlas,
  faAtlas : fonts.faAtlas,
  faVirus : fonts.faVirus,
  faEnvelopeCircleCheck : fonts.faEnvelopeCircleCheck,
  faLayerGroup : fonts.faLayerGroup,
  faArrowsToDot : fonts.faArrowsToDot,
  faArchway : fonts.faArchway,
  faHeartCircleCheck : fonts.faHeartCircleCheck,
  faHouseChimneyCrack : fonts.faHouseChimneyCrack,
  faHouseDamage : fonts.faHouseDamage,
  faFileZipper : fonts.faFileZipper,
  faFileArchive : fonts.faFileArchive,
  faSquare : fonts.faSquare,
  faMartiniGlassEmpty : fonts.faMartiniGlassEmpty,
  faGlassMartini : fonts.faGlassMartini,
  faCouch : fonts.faCouch,
  faCediSign : fonts.faCediSign,
  faItalic : fonts.faItalic,
  faChurch : fonts.faChurch,
  faCommentsDollar : fonts.faCommentsDollar,
  faDemocrat : fonts.faDemocrat,
  faZ : fonts.faZ,
  faPersonSkiing : fonts.faPersonSkiing,
  faSkiing : fonts.faSkiing,
  faRoadLock : fonts.faRoadLock,
  faA : fonts.faA,
  faTemperatureArrowDown : fonts.faTemperatureArrowDown,
  faTemperatureDown : fonts.faTemperatureDown,
  faFeatherPointed : fonts.faFeatherPointed,
  faFeatherAlt : fonts.faFeatherAlt,
  faP : fonts.faP,
  faSnowflake : fonts.faSnowflake,
  faNewspaper : fonts.faNewspaper,
  faRectangleAd : fonts.faRectangleAd,
  faAd : fonts.faAd,
  faCircleArrowRight : fonts.faCircleArrowRight,
  faArrowCircleRight : fonts.faArrowCircleRight,
  faFilterCircleXmark : fonts.faFilterCircleXmark,
  faLocust : fonts.faLocust,
  faSort : fonts.faSort,
  faUnsorted : fonts.faUnsorted,
  faListOl : fonts.faListOl,
  faList12 : fonts.faList12,
  faListNumeric : fonts.faListNumeric,
  faPersonDressBurst : fonts.faPersonDressBurst,
  faMoneyCheckDollar : fonts.faMoneyCheckDollar,
  faMoneyCheckAlt : fonts.faMoneyCheckAlt,
  faVectorSquare : fonts.faVectorSquare,
  faBreadSlice : fonts.faBreadSlice,
  faLanguage : fonts.faLanguage,
  faFaceKissWinkHeart : fonts.faFaceKissWinkHeart,
  faKissWinkHeart : fonts.faKissWinkHeart,
  faFilter : fonts.faFilter,
  faQuestion : fonts.faQuestion,
  faFileSignature : fonts.faFileSignature,
  faUpDownLeftRight : fonts.faUpDownLeftRight,
  faArrowsAlt : fonts.faArrowsAlt,
  faHouseChimneyUser : fonts.faHouseChimneyUser,
  faHandHoldingHeart : fonts.faHandHoldingHeart,
  faPuzzlePiece : fonts.faPuzzlePiece,
  faMoneyCheck : fonts.faMoneyCheck,
  faStarHalfStroke : fonts.faStarHalfStroke,
  faStarHalfAlt : fonts.faStarHalfAlt,
  faCode : fonts.faCode,
  faWhiskeyGlass : fonts.faWhiskeyGlass,
  faGlassWhiskey : fonts.faGlassWhiskey,
  faBuildingCircleExclamation : fonts.faBuildingCircleExclamation,
  faMagnifyingGlassChart : fonts.faMagnifyingGlassChart,
  faArrowUpRightFromSquare : fonts.faArrowUpRightFromSquare,
  faExternalLink : fonts.faExternalLink,
  faCubesStacked : fonts.faCubesStacked,
  faWonSign : fonts.faWonSign,
  faKrw : fonts.faKrw,
  faWon : fonts.faWon,
  faVirusCovid : fonts.faVirusCovid,
  faAustralSign : fonts.faAustralSign,
  faF : fonts.faF,
  faLeaf : fonts.faLeaf,
  faRoad : fonts.faRoad,
  faTaxi : fonts.faTaxi,
  faCab : fonts.faCab,
  faPersonCirclePlus : fonts.faPersonCirclePlus,
  faChartPie : fonts.faChartPie,
  faPieChart : fonts.faPieChart,
  faBoltLightning : fonts.faBoltLightning,
  faSackXmark : fonts.faSackXmark,
  faFileExcel : fonts.faFileExcel,
  faFileContract : fonts.faFileContract,
  faFishFins : fonts.faFishFins,
  faBuildingFlag : fonts.faBuildingFlag,
  faFaceGrinBeam : fonts.faFaceGrinBeam,
  faGrinBeam : fonts.faGrinBeam,
  faObjectUngroup : fonts.faObjectUngroup,
  faPoop : fonts.faPoop,
  faLocationPin : fonts.faLocationPin,
  faMapMarker : fonts.faMapMarker,
  faKaaba : fonts.faKaaba,
  faToiletPaper : fonts.faToiletPaper,
  faHelmetSafety : fonts.faHelmetSafety,
  faHardHat : fonts.faHardHat,
  faHatHard : fonts.faHatHard,
  faEject : fonts.faEject,
  faCircleRight : fonts.faCircleRight,
  faArrowAltCircleRight : fonts.faArrowAltCircleRight,
  faPlaneCircleCheck : fonts.faPlaneCircleCheck,
  faFaceRollingEyes : fonts.faFaceRollingEyes,
  faMehRollingEyes : fonts.faMehRollingEyes,
  faObjectGroup : fonts.faObjectGroup,
  faChartLine : fonts.faChartLine,
  faLineChart : fonts.faLineChart,
  faMaskVentilator : fonts.faMaskVentilator,
  faArrowRight : fonts.faArrowRight,
  faSignsPost : fonts.faSignsPost,
  faMapSigns : fonts.faMapSigns,
  faCashRegister : fonts.faCashRegister,
  faPersonCircleQuestion : fonts.faPersonCircleQuestion,
  faH : fonts.faH,
  faTarp : fonts.faTarp,
  faScrewdriverWrench : fonts.faScrewdriverWrench,
  faTools : fonts.faTools,
  faArrowsToEye : fonts.faArrowsToEye,
  faPlugCircleBolt : fonts.faPlugCircleBolt,
  faHeart : fonts.faHeart,
  faMarsAndVenus : fonts.faMarsAndVenus,
  faHouseUser : fonts.faHouseUser,
  faHomeUser : fonts.faHomeUser,
  faDumpsterFire : fonts.faDumpsterFire,
  faHouseCrack : fonts.faHouseCrack,
  faMartiniGlassCitrus : fonts.faMartiniGlassCitrus,
  faCocktail : fonts.faCocktail,
  faFaceSurprise : fonts.faFaceSurprise,
  faSurprise : fonts.faSurprise,
  faBottleWater : fonts.faBottleWater,
  faCirclePause : fonts.faCirclePause,
  faPauseCircle : fonts.faPauseCircle,
  faToiletPaperSlash : fonts.faToiletPaperSlash,
  faAppleWhole : fonts.faAppleWhole,
  faAppleAlt : fonts.faAppleAlt,
  faKitchenSet : fonts.faKitchenSet,
  faR : fonts.faR,
  faTemperatureQuarter : fonts.faTemperatureQuarter,
  faTemperature1 : fonts.faTemperature1,
  faThermometer1 : fonts.faThermometer1,
  faThermometerQuarter : fonts.faThermometerQuarter,
  faCube : fonts.faCube,
  faBitcoinSign : fonts.faBitcoinSign,
  faShieldDog : fonts.faShieldDog,
  faSolarPanel : fonts.faSolarPanel,
  faLockOpen : fonts.faLockOpen,
  faElevator : fonts.faElevator,
  faMoneyBillTransfer : fonts.faMoneyBillTransfer,
  faMoneyBillTrendUp : fonts.faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight : fonts.faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal : fonts.faSquarePollHorizontal,
  faPollH : fonts.faPollH,
  faCircle : fonts.faCircle,
  faBackwardFast : fonts.faBackwardFast,
  faFastBackward : fonts.faFastBackward,
  faRecycle : fonts.faRecycle,
  faUserAstronaut : fonts.faUserAstronaut,
  faPlaneSlash : fonts.faPlaneSlash,
  faTrademark : fonts.faTrademark,
  faBasketball : fonts.faBasketball,
  faBasketballBall : fonts.faBasketballBall,
  faSatelliteDish : fonts.faSatelliteDish,
  faCircleUp : fonts.faCircleUp,
  faArrowAltCircleUp : fonts.faArrowAltCircleUp,
  faMobileScreenButton : fonts.faMobileScreenButton,
  faMobileAlt : fonts.faMobileAlt,
  faVolumeHigh : fonts.faVolumeHigh,
  faVolumeUp : fonts.faVolumeUp,
  faUsersRays : fonts.faUsersRays,
  faWallet : fonts.faWallet,
  faClipboardCheck : fonts.faClipboardCheck,
  faFileAudio : fonts.faFileAudio,
  faBurger : fonts.faBurger,
  faHamburger : fonts.faHamburger,
  faWrench : fonts.faWrench,
  faBugs : fonts.faBugs,
  faRupeeSign : fonts.faRupeeSign,
  faRupee : fonts.faRupee,
  faFileImage : fonts.faFileImage,
  faCircleQuestion : fonts.faCircleQuestion,
  faQuestionCircle : fonts.faQuestionCircle,
  faPlaneDeparture : fonts.faPlaneDeparture,
  faHandshakeSlash : fonts.faHandshakeSlash,
  faBookBookmark : fonts.faBookBookmark,
  faCodeBranch : fonts.faCodeBranch,
  faHatCowboy : fonts.faHatCowboy,
  faBridge : fonts.faBridge,
  faPhoneFlip : fonts.faPhoneFlip,
  faPhoneAlt : fonts.faPhoneAlt,
  faTruckFront : fonts.faTruckFront,
  faCat : fonts.faCat,
  faAnchorCircleExclamation : fonts.faAnchorCircleExclamation,
  faTruckField : fonts.faTruckField,
  faRoute : fonts.faRoute,
  faClipboardQuestion : fonts.faClipboardQuestion,
  faPanorama : fonts.faPanorama,
  faCommentMedical : fonts.faCommentMedical,
  faTeethOpen : fonts.faTeethOpen,
  faFileCircleMinus : fonts.faFileCircleMinus,
  faTags : fonts.faTags,
  faWineGlass : fonts.faWineGlass,
  faForwardFast : fonts.faForwardFast,
  faFastForward : fonts.faFastForward,
  faFaceMehBlank : fonts.faFaceMehBlank,
  faMehBlank : fonts.faMehBlank,
  faSquareParking : fonts.faSquareParking,
  faParking : fonts.faParking,
  faHouseSignal : fonts.faHouseSignal,
  faBarsProgress : fonts.faBarsProgress,
  faTasksAlt : fonts.faTasksAlt,
  faFaucetDrip : fonts.faFaucetDrip,
  faCartFlatbed : fonts.faCartFlatbed,
  faDollyFlatbed : fonts.faDollyFlatbed,
  faBanSmoking : fonts.faBanSmoking,
  faSmokingBan : fonts.faSmokingBan,
  faTerminal : fonts.faTerminal,
  faMobileButton : fonts.faMobileButton,
  faHouseMedicalFlag : fonts.faHouseMedicalFlag,
  faBasketShopping : fonts.faBasketShopping,
  faShoppingBasket : fonts.faShoppingBasket,
  faTape : fonts.faTape,
  faBusSimple : fonts.faBusSimple,
  faBusAlt : fonts.faBusAlt,
  faEye : fonts.faEye,
  faFaceSadCry : fonts.faFaceSadCry,
  faSadCry : fonts.faSadCry,
  faAudioDescription : fonts.faAudioDescription,
  faPersonMilitaryToPerson : fonts.faPersonMilitaryToPerson,
  faFileShield : fonts.faFileShield,
  faUserSlash : fonts.faUserSlash,
  faPen : fonts.faPen,
  faTowerObservation : fonts.faTowerObservation,
  faFileCode : fonts.faFileCode,
  faSignal : fonts.faSignal,
  faSignal5 : fonts.faSignal5,
  faSignalPerfect : fonts.faSignalPerfect,
  faBus : fonts.faBus,
  faHeartCircleXmark : fonts.faHeartCircleXmark,
  faHouseChimney : fonts.faHouseChimney,
  faHomeLg : fonts.faHomeLg,
  faWindowMaximize : fonts.faWindowMaximize,
  faFaceFrown : fonts.faFaceFrown,
  faFrown : fonts.faFrown,
  faPrescription : fonts.faPrescription,
  faShop : fonts.faShop,
  faStoreAlt : fonts.faStoreAlt,
  faFloppyDisk : fonts.faFloppyDisk,
  faSave : fonts.faSave,
  faVihara : fonts.faVihara,
  faScaleUnbalanced : fonts.faScaleUnbalanced,
  faBalanceScaleLeft : fonts.faBalanceScaleLeft,
  faSortUp : fonts.faSortUp,
  faSortAsc : fonts.faSortAsc,
  faCommentDots : fonts.faCommentDots,
  faCommenting : fonts.faCommenting,
  faPlantWilt : fonts.faPlantWilt,
  faDiamond : fonts.faDiamond,
  faFaceGrinSquint : fonts.faFaceGrinSquint,
  faGrinSquint : fonts.faGrinSquint,
  faHandHoldingDollar : fonts.faHandHoldingDollar,
  faHandHoldingUsd : fonts.faHandHoldingUsd,
  faBacterium : fonts.faBacterium,
  faHandPointer : fonts.faHandPointer,
  faDrumSteelpan : fonts.faDrumSteelpan,
  faHandScissors : fonts.faHandScissors,
  faHandsPraying : fonts.faHandsPraying,
  faPrayingHands : fonts.faPrayingHands,
  faArrowRotateRight : fonts.faArrowRotateRight,
  faArrowRightRotate : fonts.faArrowRightRotate,
  faArrowRotateForward : fonts.faArrowRotateForward,
  faRedo : fonts.faRedo,
  faBiohazard : fonts.faBiohazard,
  faLocationCrosshairs : fonts.faLocationCrosshairs,
  faLocation : fonts.faLocation,
  faMarsDouble : fonts.faMarsDouble,
  faChildDress : fonts.faChildDress,
  faUsersBetweenLines : fonts.faUsersBetweenLines,
  faLungsVirus : fonts.faLungsVirus,
  faFaceGrinTears : fonts.faFaceGrinTears,
  faGrinTears : fonts.faGrinTears,
  faPhone : fonts.faPhone,
  faCalendarXmark : fonts.faCalendarXmark,
  faCalendarTimes : fonts.faCalendarTimes,
  faChildReaching : fonts.faChildReaching,
  faHeadSideVirus : fonts.faHeadSideVirus,
  faUserGear : fonts.faUserGear,
  faUserCog : fonts.faUserCog,
  faArrowUp19 : fonts.faArrowUp19,
  faSortNumericUp : fonts.faSortNumericUp,
  faDoorClosed : fonts.faDoorClosed,
  faShieldVirus : fonts.faShieldVirus,
  faDiceSix : fonts.faDiceSix,
  faMosquitoNet : fonts.faMosquitoNet,
  faBridgeWater : fonts.faBridgeWater,
  faPersonBooth : fonts.faPersonBooth,
  faTextWidth : fonts.faTextWidth,
  faHatWizard : fonts.faHatWizard,
  faPenFancy : fonts.faPenFancy,
  faPersonDigging : fonts.faPersonDigging,
  faDigging : fonts.faDigging,
  faTrash : fonts.faTrash,
  faGaugeSimple : fonts.faGaugeSimple,
  faGaugeSimpleMed : fonts.faGaugeSimpleMed,
  faTachometerAverage : fonts.faTachometerAverage,
  faBookMedical : fonts.faBookMedical,
  faPoo : fonts.faPoo,
  faQuoteRight : fonts.faQuoteRight,
  faQuoteRightAlt : fonts.faQuoteRightAlt,
  faShirt : fonts.faShirt,
  faTShirt : fonts.faTShirt,
  faTshirt : fonts.faTshirt,
  faCubes : fonts.faCubes,
  faDivide : fonts.faDivide,
  faTengeSign : fonts.faTengeSign,
  faTenge : fonts.faTenge,
  faHeadphones : fonts.faHeadphones,
  faHandsHolding : fonts.faHandsHolding,
  faHandsClapping : fonts.faHandsClapping,
  faRepublican : fonts.faRepublican,
  faArrowLeft : fonts.faArrowLeft,
  faPersonCircleXmark : fonts.faPersonCircleXmark,
  faRuler : fonts.faRuler,
  faAlignLeft : fonts.faAlignLeft,
  faDiceD6 : fonts.faDiceD6,
  faRestroom : fonts.faRestroom,
  faJ : fonts.faJ,
  faUsersViewfinder : fonts.faUsersViewfinder,
  faFileVideo : fonts.faFileVideo,
  faUpRightFromSquare : fonts.faUpRightFromSquare,
  faExternalLinkAlt : fonts.faExternalLinkAlt,
  faTableCells : fonts.faTableCells,
  faTh : fonts.faTh,
  faFilePdf : fonts.faFilePdf,
  faBookBible : fonts.faBookBible,
  faBible : fonts.faBible,
  faO : fonts.faO,
  faSuitcaseMedical : fonts.faSuitcaseMedical,
  faMedkit : fonts.faMedkit,
  faUserSecret : fonts.faUserSecret,
  faOtter : fonts.faOtter,
  faPersonDress : fonts.faPersonDress,
  faFemale : fonts.faFemale,
  faCommentDollar : fonts.faCommentDollar,
  faBusinessTime : fonts.faBusinessTime,
  faBriefcaseClock : fonts.faBriefcaseClock,
  faTableCellsLarge : fonts.faTableCellsLarge,
  faThLarge : fonts.faThLarge,
  faBookTanakh : fonts.faBookTanakh,
  faTanakh : fonts.faTanakh,
  faPhoneVolume : fonts.faPhoneVolume,
  faVolumeControlPhone : fonts.faVolumeControlPhone,
  faHatCowboySide : fonts.faHatCowboySide,
  faClipboardUser : fonts.faClipboardUser,
  faChild : fonts.faChild,
  faLiraSign : fonts.faLiraSign,
  faSatellite : fonts.faSatellite,
  faPlaneLock : fonts.faPlaneLock,
  faTag : fonts.faTag,
  faComment : fonts.faComment,
  faCakeCandles : fonts.faCakeCandles,
  faBirthdayCake : fonts.faBirthdayCake,
  faCake : fonts.faCake,
  faEnvelope : fonts.faEnvelope,
  faAnglesUp : fonts.faAnglesUp,
  faAngleDoubleUp : fonts.faAngleDoubleUp,
  faPaperclip : fonts.faPaperclip,
  faArrowRightToCity : fonts.faArrowRightToCity,
  faRibbon : fonts.faRibbon,
  faLungs : fonts.faLungs,
  faArrowUp91 : fonts.faArrowUp91,
  faSortNumericUpAlt : fonts.faSortNumericUpAlt,
  faLitecoinSign : fonts.faLitecoinSign,
  faBorderNone : fonts.faBorderNone,
  faCircleNodes : fonts.faCircleNodes,
  faParachuteBox : fonts.faParachuteBox,
  faIndent : fonts.faIndent,
  faTruckFieldUn : fonts.faTruckFieldUn,
  faHourglass : fonts.faHourglass,
  faHourglassEmpty : fonts.faHourglassEmpty,
  faMountain : fonts.faMountain,
  faUserDoctor : fonts.faUserDoctor,
  faUserMd : fonts.faUserMd,
  faCircleInfo : fonts.faCircleInfo,
  faInfoCircle : fonts.faInfoCircle,
  faCloudMeatball : fonts.faCloudMeatball,
  faCamera : fonts.faCamera,
  faCameraAlt : fonts.faCameraAlt,
  faSquareVirus : fonts.faSquareVirus,
  faMeteor : fonts.faMeteor,
  faCarOn : fonts.faCarOn,
  faSleigh : fonts.faSleigh,
  faArrowDown19 : fonts.faArrowDown19,
  faSortNumericAsc : fonts.faSortNumericAsc,
  faSortNumericDown : fonts.faSortNumericDown,
  faHandHoldingDroplet : fonts.faHandHoldingDroplet,
  faHandHoldingWater : fonts.faHandHoldingWater,
  faWater : fonts.faWater,
  faCalendarCheck : fonts.faCalendarCheck,
  faBraille : fonts.faBraille,
  faPrescriptionBottleMedical : fonts.faPrescriptionBottleMedical,
  faPrescriptionBottleAlt : fonts.faPrescriptionBottleAlt,
  faLandmark : fonts.faLandmark,
  faTruck : fonts.faTruck,
  faCrosshairs : fonts.faCrosshairs,
  faPersonCane : fonts.faPersonCane,
  faTent : fonts.faTent,
  faVestPatches : fonts.faVestPatches,
  faCheckDouble : fonts.faCheckDouble,
  faArrowDownAZ : fonts.faArrowDownAZ,
  faSortAlphaAsc : fonts.faSortAlphaAsc,
  faSortAlphaDown : fonts.faSortAlphaDown,
  faMoneyBillWheat : fonts.faMoneyBillWheat,
  faCookie : fonts.faCookie,
  faArrowRotateLeft : fonts.faArrowRotateLeft,
  faArrowLeftRotate : fonts.faArrowLeftRotate,
  faArrowRotateBack : fonts.faArrowRotateBack,
  faArrowRotateBackward : fonts.faArrowRotateBackward,
  faUndo : fonts.faUndo,
  faHardDrive : fonts.faHardDrive,
  faHdd : fonts.faHdd,
  faFaceGrinSquintTears : fonts.faFaceGrinSquintTears,
  faGrinSquintTears : fonts.faGrinSquintTears,
  faDumbbell : fonts.faDumbbell,
  faRectangleList : fonts.faRectangleList,
  faListAlt : fonts.faListAlt,
  faTarpDroplet : fonts.faTarpDroplet,
  faHouseMedicalCircleCheck : fonts.faHouseMedicalCircleCheck,
  faPersonSkiingNordic : fonts.faPersonSkiingNordic,
  faSkiingNordic : fonts.faSkiingNordic,
  faCalendarPlus : fonts.faCalendarPlus,
  faPlaneArrival : fonts.faPlaneArrival,
  faCircleLeft : fonts.faCircleLeft,
  faArrowAltCircleLeft : fonts.faArrowAltCircleLeft,
  faTrainSubway : fonts.faTrainSubway,
  faSubway : fonts.faSubway,
  faChartGantt : fonts.faChartGantt,
  faIndianRupeeSign : fonts.faIndianRupeeSign,
  faIndianRupee : fonts.faIndianRupee,
  faInr : fonts.faInr,
  faCropSimple : fonts.faCropSimple,
  faCropAlt : fonts.faCropAlt,
  faMoneyBill1 : fonts.faMoneyBill1,
  faMoneyBillAlt : fonts.faMoneyBillAlt,
  faLeftLong : fonts.faLeftLong,
  faLongArrowAltLeft : fonts.faLongArrowAltLeft,
  faDna : fonts.faDna,
  faVirusSlash : fonts.faVirusSlash,
  faMinus : fonts.faMinus,
  faSubtract : fonts.faSubtract,
  faChess : fonts.faChess,
  faArrowLeftLong : fonts.faArrowLeftLong,
  faLongArrowLeft : fonts.faLongArrowLeft,
  faPlugCircleCheck : fonts.faPlugCircleCheck,
  faStreetView : fonts.faStreetView,
  faFrancSign : fonts.faFrancSign,
  faVolumeOff : fonts.faVolumeOff,
  faHandsAslInterpreting : fonts.faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting : fonts.faAmericanSignLanguageInterpreting,
  faAslInterpreting : fonts.faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting : fonts.faHandsAmericanSignLanguageInterpreting,
  faGear : fonts.faGear,
  faCog : fonts.faCog,
  faDropletSlash : fonts.faDropletSlash,
  faTintSlash : fonts.faTintSlash,
  faMosque : fonts.faMosque,
  faMosquito : fonts.faMosquito,
  faStarOfDavid : fonts.faStarOfDavid,
  faPersonMilitaryRifle : fonts.faPersonMilitaryRifle,
  faCartShopping : fonts.faCartShopping,
  faShoppingCart : fonts.faShoppingCart,
  faVials : fonts.faVials,
  faPlugCirclePlus : fonts.faPlugCirclePlus,
  faPlaceOfWorship : fonts.faPlaceOfWorship,
  faGripVertical : fonts.faGripVertical,
  faArrowTurnUp : fonts.faArrowTurnUp,
  faLevelUp : fonts.faLevelUp,
  faU : fonts.faU,
  faSquareRootVariable : fonts.faSquareRootVariable,
  faSquareRootAlt : fonts.faSquareRootAlt,
  faClock : fonts.faClock,
  faClockFour : fonts.faClockFour,
  faBackwardStep : fonts.faBackwardStep,
  faStepBackward : fonts.faStepBackward,
  faPallet : fonts.faPallet,
  faFaucet : fonts.faFaucet,
  faBaseballBatBall : fonts.faBaseballBatBall,
  faS : fonts.faS,
  faTimeline : fonts.faTimeline,
  faKeyboard : fonts.faKeyboard,
  faCaretDown : fonts.faCaretDown,
  faHouseChimneyMedical : fonts.faHouseChimneyMedical,
  faClinicMedical : fonts.faClinicMedical,
  faTemperatureThreeQuarters : fonts.faTemperatureThreeQuarters,
  faTemperature3 : fonts.faTemperature3,
  faThermometer3 : fonts.faThermometer3,
  faThermometerThreeQuarters : fonts.faThermometerThreeQuarters,
  faMobileScreen : fonts.faMobileScreen,
  faMobileAndroidAlt : fonts.faMobileAndroidAlt,
  faPlaneUp : fonts.faPlaneUp,
  faPiggyBank : fonts.faPiggyBank,
  faBatteryHalf : fonts.faBatteryHalf,
  faBattery3 : fonts.faBattery3,
  faMountainCity : fonts.faMountainCity,
  faCoins : fonts.faCoins,
  faKhanda : fonts.faKhanda,
  faSliders : fonts.faSliders,
  faSlidersH : fonts.faSlidersH,
  faFolderTree : fonts.faFolderTree,
  faNetworkWired : fonts.faNetworkWired,
  faMapPin : fonts.faMapPin,
  faHamsa : fonts.faHamsa,
  faCentSign : fonts.faCentSign,
  faFlask : fonts.faFlask,
  faPersonPregnant : fonts.faPersonPregnant,
  faWandSparkles : fonts.faWandSparkles,
  faEllipsisVertical : fonts.faEllipsisVertical,
  faEllipsisV : fonts.faEllipsisV,
  faTicket : fonts.faTicket,
  faPowerOff : fonts.faPowerOff,
  faRightLong : fonts.faRightLong,
  faLongArrowAltRight : fonts.faLongArrowAltRight,
  faFlagUsa : fonts.faFlagUsa,
  faLaptopFile : fonts.faLaptopFile,
  faTty : fonts.faTty,
  faTeletype : fonts.faTeletype,
  faDiagramNext : fonts.faDiagramNext,
  faPersonRifle : fonts.faPersonRifle,
  faHouseMedicalCircleExclamation : fonts.faHouseMedicalCircleExclamation,
  faClosedCaptioning : fonts.faClosedCaptioning,
  faPersonHiking : fonts.faPersonHiking,
  faHiking : fonts.faHiking,
  faVenusDouble : fonts.faVenusDouble,
  faImages : fonts.faImages,
  faCalculator : fonts.faCalculator,
  faPeoplePulling : fonts.faPeoplePulling,
  faN : fonts.faN,
  faCableCar : fonts.faCableCar,
  faTram : fonts.faTram,
  faCloudRain : fonts.faCloudRain,
  faBuildingCircleXmark : fonts.faBuildingCircleXmark,
  faShip : fonts.faShip,
  faArrowsDownToLine : fonts.faArrowsDownToLine,
  faDownload : fonts.faDownload,
  faFaceGrin : fonts.faFaceGrin,
  faGrin : fonts.faGrin,
  faDeleteLeft : fonts.faDeleteLeft,
  faBackspace : fonts.faBackspace,
  faEyeDropper : fonts.faEyeDropper,
  faEyeDropperEmpty : fonts.faEyeDropperEmpty,
  faEyedropper : fonts.faEyedropper,
  faFileCircleCheck : fonts.faFileCircleCheck,
  faForward : fonts.faForward,
  faMobile : fonts.faMobile,
  faMobileAndroid : fonts.faMobileAndroid,
  faMobilePhone : fonts.faMobilePhone,
  faFaceMeh : fonts.faFaceMeh,
  faMeh : fonts.faMeh,
  faAlignCenter : fonts.faAlignCenter,
  faBookSkull : fonts.faBookSkull,
  faBookDead : fonts.faBookDead,
  faIdCard : fonts.faIdCard,
  faDriversLicense : fonts.faDriversLicense,
  faOutdent : fonts.faOutdent,
  faDedent : fonts.faDedent,
  faHeartCircleExclamation : fonts.faHeartCircleExclamation,
  faHouse : fonts.faHouse,
  faHome : fonts.faHome,
  faHomeAlt : fonts.faHomeAlt,
  faHomeLgAlt : fonts.faHomeLgAlt,
  faCalendarWeek : fonts.faCalendarWeek,
  faLaptopMedical : fonts.faLaptopMedical,
  faB : fonts.faB,
  faFileMedical : fonts.faFileMedical,
  faDiceOne : fonts.faDiceOne,
  faKiwiBird : fonts.faKiwiBird,
  faArrowRightArrowLeft : fonts.faArrowRightArrowLeft,
  faExchange : fonts.faExchange,
  faRotateRight : fonts.faRotateRight,
  faRedoAlt : fonts.faRedoAlt,
  faRotateForward : fonts.faRotateForward,
  faUtensils : fonts.faUtensils,
  faCutlery : fonts.faCutlery,
  faArrowUpWideShort : fonts.faArrowUpWideShort,
  faSortAmountUp : fonts.faSortAmountUp,
  faMillSign : fonts.faMillSign,
  faBowlRice : fonts.faBowlRice,
  faSkull : fonts.faSkull,
  faTowerBroadcast : fonts.faTowerBroadcast,
  faBroadcastTower : fonts.faBroadcastTower,
  faTruckPickup : fonts.faTruckPickup,
  faUpLong : fonts.faUpLong,
  faLongArrowAltUp : fonts.faLongArrowAltUp,
  faStop : fonts.faStop,
  faCodeMerge : fonts.faCodeMerge,
  faUpload : fonts.faUpload,
  faHurricane : fonts.faHurricane,
  faMound : fonts.faMound,
  faToiletPortable : fonts.faToiletPortable,
  faCompactDisc : fonts.faCompactDisc,
  faFileArrowDown : fonts.faFileArrowDown,
  faFileDownload : fonts.faFileDownload,
  faCaravan : fonts.faCaravan,
  faShieldCat : fonts.faShieldCat,
  faBolt : fonts.faBolt,
  faZap : fonts.faZap,
  faGlassWater : fonts.faGlassWater,
  faOilWell : fonts.faOilWell,
  faVault : fonts.faVault,
  faMars : fonts.faMars,
  faToilet : fonts.faToilet,
  faPlaneCircleXmark : fonts.faPlaneCircleXmark,
  faYenSign : fonts.faYenSign,
  faCny : fonts.faCny,
  faJpy : fonts.faJpy,
  faRmb : fonts.faRmb,
  faYen : fonts.faYen,
  faRubleSign : fonts.faRubleSign,
  faRouble : fonts.faRouble,
  faRub : fonts.faRub,
  faRuble : fonts.faRuble,
  faSun : fonts.faSun,
  faGuitar : fonts.faGuitar,
  faFaceLaughWink : fonts.faFaceLaughWink,
  faLaughWink : fonts.faLaughWink,
  faHorseHead : fonts.faHorseHead,
  faBoreHole : fonts.faBoreHole,
  faIndustry : fonts.faIndustry,
  faCircleDown : fonts.faCircleDown,
  faArrowAltCircleDown : fonts.faArrowAltCircleDown,
  faArrowsTurnToDots : fonts.faArrowsTurnToDots,
  faFlorinSign : fonts.faFlorinSign,
  faArrowDownShortWide : fonts.faArrowDownShortWide,
  faSortAmountDesc : fonts.faSortAmountDesc,
  faSortAmountDownAlt : fonts.faSortAmountDownAlt,
  faLessThan : fonts.faLessThan,
  faAngleDown : fonts.faAngleDown,
  faCarTunnel : fonts.faCarTunnel,
  faHeadSideCough : fonts.faHeadSideCough,
  faGripLines : fonts.faGripLines,
  faThumbsDown : fonts.faThumbsDown,
  faUserLock : fonts.faUserLock,
  faArrowRightLong : fonts.faArrowRightLong,
  faLongArrowRight : fonts.faLongArrowRight,
  faAnchorCircleXmark : fonts.faAnchorCircleXmark,
  faEllipsis : fonts.faEllipsis,
  faEllipsisH : fonts.faEllipsisH,
  faChessPawn : fonts.faChessPawn,
  faKitMedical : fonts.faKitMedical,
  faFirstAid : fonts.faFirstAid,
  faPersonThroughWindow : fonts.faPersonThroughWindow,
  faToolbox : fonts.faToolbox,
  faHandsHoldingCircle : fonts.faHandsHoldingCircle,
  faBug : fonts.faBug,
  faCreditCard : fonts.faCreditCard,
  faCreditCardAlt : fonts.faCreditCardAlt,
  faCar : fonts.faCar,
  faAutomobile : fonts.faAutomobile,
  faHandHoldingHand : fonts.faHandHoldingHand,
  faBookOpenReader : fonts.faBookOpenReader,
  faBookReader : fonts.faBookReader,
  faMountainSun : fonts.faMountainSun,
  faArrowsLeftRightToLine : fonts.faArrowsLeftRightToLine,
  faDiceD20 : fonts.faDiceD20,
  faTruckDroplet : fonts.faTruckDroplet,
  faFileCircleXmark : fonts.faFileCircleXmark,
  faTemperatureArrowUp : fonts.faTemperatureArrowUp,
  faTemperatureUp : fonts.faTemperatureUp,
  faMedal : fonts.faMedal,
  faBed : fonts.faBed,
  faSquareH : fonts.faSquareH,
  faHSquare : fonts.faHSquare,
  faPodcast : fonts.faPodcast,
  faTemperatureFull : fonts.faTemperatureFull,
  faTemperature4 : fonts.faTemperature4,
  faThermometer4 : fonts.faThermometer4,
  faThermometerFull : fonts.faThermometerFull,
  faBell : fonts.faBell,
  faSuperscript : fonts.faSuperscript,
  faPlugCircleXmark : fonts.faPlugCircleXmark,
  faStarOfLife : fonts.faStarOfLife,
  faPhoneSlash : fonts.faPhoneSlash,
  faPaintRoller : fonts.faPaintRoller,
  faHandshakeAngle : fonts.faHandshakeAngle,
  faHandsHelping : fonts.faHandsHelping,
  faLocationDot : fonts.faLocationDot,
  faMapMarkerAlt : fonts.faMapMarkerAlt,
  faFile : fonts.faFile,
  faGreaterThan : fonts.faGreaterThan,
  faPersonSwimming : fonts.faPersonSwimming,
  faSwimmer : fonts.faSwimmer,
  faArrowDown : fonts.faArrowDown,
  faDroplet : fonts.faDroplet,
  faTint : fonts.faTint,
  faEraser : fonts.faEraser,
  faEarthAmericas : fonts.faEarthAmericas,
  faEarth : fonts.faEarth,
  faEarthAmerica : fonts.faEarthAmerica,
  faGlobeAmericas : fonts.faGlobeAmericas,
  faPersonBurst : fonts.faPersonBurst,
  faDove : fonts.faDove,
  faBatteryEmpty : fonts.faBatteryEmpty,
  faBattery0 : fonts.faBattery0,
  faSocks : fonts.faSocks,
  faInbox : fonts.faInbox,
  faSection : fonts.faSection,
  faGaugeHigh : fonts.faGaugeHigh,
  faTachometerAlt : fonts.faTachometerAlt,
  faTachometerAltFast : fonts.faTachometerAltFast,
  faEnvelopeOpenText : fonts.faEnvelopeOpenText,
  faHospital : fonts.faHospital,
  faHospitalAlt : fonts.faHospitalAlt,
  faHospitalWide : fonts.faHospitalWide,
  faWineBottle : fonts.faWineBottle,
  faChessRook : fonts.faChessRook,
  faBarsStaggered : fonts.faBarsStaggered,
  faReorder : fonts.faReorder,
  faStream : fonts.faStream,
  faDharmachakra : fonts.faDharmachakra,
  faHotdog : fonts.faHotdog,
  faPersonWalkingWithCane : fonts.faPersonWalkingWithCane,
  faBlind : fonts.faBlind,
  faDrum : fonts.faDrum,
  faIceCream : fonts.faIceCream,
  faHeartCircleBolt : fonts.faHeartCircleBolt,
  faFax : fonts.faFax,
  faParagraph : fonts.faParagraph,
  faCheckToSlot : fonts.faCheckToSlot,
  faVoteYea : fonts.faVoteYea,
  faStarHalf : fonts.faStarHalf,
  faBoxesStacked : fonts.faBoxesStacked,
  faBoxes : fonts.faBoxes,
  faBoxesAlt : fonts.faBoxesAlt,
  faLink : fonts.faLink,
  faChain : fonts.faChain,
  faEarListen : fonts.faEarListen,
  faAssistiveListeningSystems : fonts.faAssistiveListeningSystems,
  faTreeCity : fonts.faTreeCity,
  faPlay : fonts.faPlay,
  faFont : fonts.faFont,
  faRupiahSign : fonts.faRupiahSign,
  faMagnifyingGlass : fonts.faMagnifyingGlass,
  faSearch : fonts.faSearch,
  faTableTennisPaddleBall : fonts.faTableTennisPaddleBall,
  faPingPongPaddleBall : fonts.faPingPongPaddleBall,
  faTableTennis : fonts.faTableTennis,
  faPersonDotsFromLine : fonts.faPersonDotsFromLine,
  faDiagnoses : fonts.faDiagnoses,
  faTrashCanArrowUp : fonts.faTrashCanArrowUp,
  faTrashRestoreAlt : fonts.faTrashRestoreAlt,
  faNairaSign : fonts.faNairaSign,
  faCartArrowDown : fonts.faCartArrowDown,
  faWalkieTalkie : fonts.faWalkieTalkie,
  faFilePen : fonts.faFilePen,
  faFileEdit : fonts.faFileEdit,
  faReceipt : fonts.faReceipt,
  faSquarePen : fonts.faSquarePen,
  faPenSquare : fonts.faPenSquare,
  faPencilSquare : fonts.faPencilSquare,
  faSuitcaseRolling : fonts.faSuitcaseRolling,
  faPersonCircleExclamation : fonts.faPersonCircleExclamation,
  faChevronDown : fonts.faChevronDown,
  faBatteryFull : fonts.faBatteryFull,
  faBattery : fonts.faBattery,
  faBattery5 : fonts.faBattery5,
  faSkullCrossbones : fonts.faSkullCrossbones,
  faCodeCompare : fonts.faCodeCompare,
  faListUl : fonts.faListUl,
  faListDots : fonts.faListDots,
  faSchoolLock : fonts.faSchoolLock,
  faTowerCell : fonts.faTowerCell,
  faDownLong : fonts.faDownLong,
  faLongArrowAltDown : fonts.faLongArrowAltDown,
  faRankingStar : fonts.faRankingStar,
  faChessKing : fonts.faChessKing,
  faPersonHarassing : fonts.faPersonHarassing,
  faBrazilianRealSign : fonts.faBrazilianRealSign,
  faLandmarkDome : fonts.faLandmarkDome,
  faLandmarkAlt : fonts.faLandmarkAlt,
  faArrowUp : fonts.faArrowUp,
  faTv : fonts.faTv,
  faTelevision : fonts.faTelevision,
  faTvAlt : fonts.faTvAlt,
  faShrimp : fonts.faShrimp,
  faListCheck : fonts.faListCheck,
  faTasks : fonts.faTasks,
  faJugDetergent : fonts.faJugDetergent,
  faCircleUser : fonts.faCircleUser,
  faUserCircle : fonts.faUserCircle,
  faUserShield : fonts.faUserShield,
  faWind : fonts.faWind,
  faCarBurst : fonts.faCarBurst,
  faCarCrash : fonts.faCarCrash,
  faY : fonts.faY,
  faPersonSnowboarding : fonts.faPersonSnowboarding,
  faSnowboarding : fonts.faSnowboarding,
  faTruckFast : fonts.faTruckFast,
  faShippingFast : fonts.faShippingFast,
  faFish : fonts.faFish,
  faUserGraduate : fonts.faUserGraduate,
  faCircleHalfStroke : fonts.faCircleHalfStroke,
  faAdjust : fonts.faAdjust,
  faClapperboard : fonts.faClapperboard,
  faCircleRadiation : fonts.faCircleRadiation,
  faRadiationAlt : fonts.faRadiationAlt,
  faBaseball : fonts.faBaseball,
  faBaseballBall : fonts.faBaseballBall,
  faJetFighterUp : fonts.faJetFighterUp,
  faDiagramProject : fonts.faDiagramProject,
  faProjectDiagram : fonts.faProjectDiagram,
  faCopy : fonts.faCopy,
  faVolumeXmark : fonts.faVolumeXmark,
  faVolumeMute : fonts.faVolumeMute,
  faVolumeTimes : fonts.faVolumeTimes,
  faHandSparkles : fonts.faHandSparkles,
  faGrip : fonts.faGrip,
  faGripHorizontal : fonts.faGripHorizontal,
  faShareFromSquare : fonts.faShareFromSquare,
  faShareSquare : fonts.faShareSquare,
  faChildCombatant : fonts.faChildCombatant,
  faChildRifle : fonts.faChildRifle,
  faGun : fonts.faGun,
  faSquarePhone : fonts.faSquarePhone,
  faPhoneSquare : fonts.faPhoneSquare,
  faPlus : fonts.faPlus,
  faAdd : fonts.faAdd,
  faExpand : fonts.faExpand,
  faComputer : fonts.faComputer,
  faXmark : fonts.faXmark,
  faClose : fonts.faClose,
  faMultiply : fonts.faMultiply,
  faRemove : fonts.faRemove,
  faTimes : fonts.faTimes,
  faArrowsUpDownLeftRight : fonts.faArrowsUpDownLeftRight,
  faArrows : fonts.faArrows,
  faChalkboardUser : fonts.faChalkboardUser,
  faChalkboardTeacher : fonts.faChalkboardTeacher,
  faPesoSign : fonts.faPesoSign,
  faBuildingShield : fonts.faBuildingShield,
  faBaby : fonts.faBaby,
  faUsersLine : fonts.faUsersLine,
  faQuoteLeft : fonts.faQuoteLeft,
  faQuoteLeftAlt : fonts.faQuoteLeftAlt,
  faTractor : fonts.faTractor,
  faTrashArrowUp : fonts.faTrashArrowUp,
  faTrashRestore : fonts.faTrashRestore,
  faArrowDownUpLock : fonts.faArrowDownUpLock,
  faLinesLeaning : fonts.faLinesLeaning,
  faRulerCombined : fonts.faRulerCombined,
  faCopyright : fonts.faCopyright,
  faEquals : fonts.faEquals,
  faBlender : fonts.faBlender,
  faTeeth : fonts.faTeeth,
  faShekelSign : fonts.faShekelSign,
  faIls : fonts.faIls,
  faShekel : fonts.faShekel,
  faSheqel : fonts.faSheqel,
  faSheqelSign : fonts.faSheqelSign,
  faMap : fonts.faMap,
  faRocket : fonts.faRocket,
  faPhotoFilm : fonts.faPhotoFilm,
  faPhotoVideo : fonts.faPhotoVideo,
  faFolderMinus : fonts.faFolderMinus,
  faStore : fonts.faStore,
  faArrowTrendUp : fonts.faArrowTrendUp,
  faPlugCircleMinus : fonts.faPlugCircleMinus,
  faSignHanging : fonts.faSignHanging,
  faSign : fonts.faSign,
  faBezierCurve : fonts.faBezierCurve,
  faBellSlash : fonts.faBellSlash,
  faTablet : fonts.faTablet,
  faTabletAndroid : fonts.faTabletAndroid,
  faSchoolFlag : fonts.faSchoolFlag,
  faFill : fonts.faFill,
  faAngleUp : fonts.faAngleUp,
  faDrumstickBite : fonts.faDrumstickBite,
  faHollyBerry : fonts.faHollyBerry,
  faChevronLeft : fonts.faChevronLeft,
  faBacteria : fonts.faBacteria,
  faHandLizard : fonts.faHandLizard,
  faNotdef : fonts.faNotdef,
  faDisease : fonts.faDisease,
  faBriefcaseMedical : fonts.faBriefcaseMedical,
  faGenderless : fonts.faGenderless,
  faChevronRight : fonts.faChevronRight,
  faRetweet : fonts.faRetweet,
  faCarRear : fonts.faCarRear,
  faCarAlt : fonts.faCarAlt,
  faPumpSoap : fonts.faPumpSoap,
  faVideoSlash : fonts.faVideoSlash,
  faBatteryQuarter : fonts.faBatteryQuarter,
  faBattery2 : fonts.faBattery2,
  faRadio : fonts.faRadio,
  faBabyCarriage : fonts.faBabyCarriage,
  faCarriageBaby : fonts.faCarriageBaby,
  faTrafficLight : fonts.faTrafficLight,
  faThermometer : fonts.faThermometer,
  faVrCardboard : fonts.faVrCardboard,
  faHandMiddleFinger : fonts.faHandMiddleFinger,
  faPercent : fonts.faPercent,
  faPercentage : fonts.faPercentage,
  faTruckMoving : fonts.faTruckMoving,
  faGlassWaterDroplet : fonts.faGlassWaterDroplet,
  faDisplay : fonts.faDisplay,
  faFaceSmile : fonts.faFaceSmile,
  faSmile : fonts.faSmile,
  faThumbtack : fonts.faThumbtack,
  faThumbTack : fonts.faThumbTack,
  faTrophy : fonts.faTrophy,
  faPersonPraying : fonts.faPersonPraying,
  faPray : fonts.faPray,
  faHammer : fonts.faHammer,
  faHandPeace : fonts.faHandPeace,
  faRotate : fonts.faRotate,
  faSyncAlt : fonts.faSyncAlt,
  faSpinner : fonts.faSpinner,
  faRobot : fonts.faRobot,
  faPeace : fonts.faPeace,
  faGears : fonts.faGears,
  faCogs : fonts.faCogs,
  faWarehouse : fonts.faWarehouse,
  faArrowUpRightDots : fonts.faArrowUpRightDots,
  faSplotch : fonts.faSplotch,
  faFaceGrinHearts : fonts.faFaceGrinHearts,
  faGrinHearts : fonts.faGrinHearts,
  faDiceFour : fonts.faDiceFour,
  faSimCard : fonts.faSimCard,
  faTransgender : fonts.faTransgender,
  faTransgenderAlt : fonts.faTransgenderAlt,
  faMercury : fonts.faMercury,
  faArrowTurnDown : fonts.faArrowTurnDown,
  faLevelDown : fonts.faLevelDown,
  faPersonFallingBurst : fonts.faPersonFallingBurst,
  faAward : fonts.faAward,
  faTicketSimple : fonts.faTicketSimple,
  faTicketAlt : fonts.faTicketAlt,
  faBuilding : fonts.faBuilding,
  faAnglesLeft : fonts.faAnglesLeft,
  faAngleDoubleLeft : fonts.faAngleDoubleLeft,
  faQrcode : fonts.faQrcode,
  faClockRotateLeft : fonts.faClockRotateLeft,
  faHistory : fonts.faHistory,
  faFaceGrinBeamSweat : fonts.faFaceGrinBeamSweat,
  faGrinBeamSweat : fonts.faGrinBeamSweat,
  faFileExport : fonts.faFileExport,
  faArrowRightFromFile : fonts.faArrowRightFromFile,
  faShield : fonts.faShield,
  faShieldBlank : fonts.faShieldBlank,
  faArrowUpShortWide : fonts.faArrowUpShortWide,
  faSortAmountUpAlt : fonts.faSortAmountUpAlt,
  faHouseMedical : fonts.faHouseMedical,
  faGolfBallTee : fonts.faGolfBallTee,
  faGolfBall : fonts.faGolfBall,
  faCircleChevronLeft : fonts.faCircleChevronLeft,
  faChevronCircleLeft : fonts.faChevronCircleLeft,
  faHouseChimneyWindow : fonts.faHouseChimneyWindow,
  faPenNib : fonts.faPenNib,
  faTentArrowTurnLeft : fonts.faTentArrowTurnLeft,
  faTents : fonts.faTents,
  faWandMagic : fonts.faWandMagic,
  faMagic : fonts.faMagic,
  faDog : fonts.faDog,
  faCarrot : fonts.faCarrot,
  faMoon : fonts.faMoon,
  faWineGlassEmpty : fonts.faWineGlassEmpty,
  faWineGlassAlt : fonts.faWineGlassAlt,
  faCheese : fonts.faCheese,
  faYinYang : fonts.faYinYang,
  faMusic : fonts.faMusic,
  faCodeCommit : fonts.faCodeCommit,
  faTemperatureLow : fonts.faTemperatureLow,
  faPersonBiking : fonts.faPersonBiking,
  faBiking : fonts.faBiking,
  faBroom : fonts.faBroom,
  faShieldHeart : fonts.faShieldHeart,
  faGopuram : fonts.faGopuram,
  faEarthOceania : fonts.faEarthOceania,
  faGlobeOceania : fonts.faGlobeOceania,
  faSquareXmark : fonts.faSquareXmark,
  faTimesSquare : fonts.faTimesSquare,
  faXmarkSquare : fonts.faXmarkSquare,
  faHashtag : fonts.faHashtag,
  faUpRightAndDownLeftFromCenter : fonts.faUpRightAndDownLeftFromCenter,
  faExpandAlt : fonts.faExpandAlt,
  faOilCan : fonts.faOilCan,
  faT : fonts.faT,
  faHippo : fonts.faHippo,
  faChartColumn : fonts.faChartColumn,
  faInfinity : fonts.faInfinity,
  faVialCircleCheck : fonts.faVialCircleCheck,
  faPersonArrowDownToLine : fonts.faPersonArrowDownToLine,
  faVoicemail : fonts.faVoicemail,
  faFan : fonts.faFan,
  faPersonWalkingLuggage : fonts.faPersonWalkingLuggage,
  faUpDown : fonts.faUpDown,
  faArrowsAltV : fonts.faArrowsAltV,
  faCloudMoonRain : fonts.faCloudMoonRain,
  faCalendar : fonts.faCalendar,
  faTrailer : fonts.faTrailer,
  faBahai : fonts.faBahai,
  faHaykal : fonts.faHaykal,
  faSdCard : fonts.faSdCard,
  faDragon : fonts.faDragon,
  faShoePrints : fonts.faShoePrints,
  faCirclePlus : fonts.faCirclePlus,
  faPlusCircle : fonts.faPlusCircle,
  faFaceGrinTongueWink : fonts.faFaceGrinTongueWink,
  faGrinTongueWink : fonts.faGrinTongueWink,
  faHandHolding : fonts.faHandHolding,
  faPlugCircleExclamation : fonts.faPlugCircleExclamation,
  faLinkSlash : fonts.faLinkSlash,
  faChainBroken : fonts.faChainBroken,
  faChainSlash : fonts.faChainSlash,
  faUnlink : fonts.faUnlink,
  faClone : fonts.faClone,
  faPersonWalkingArrowLoopLeft : fonts.faPersonWalkingArrowLoopLeft,
  faArrowUpZA : fonts.faArrowUpZA,
  faSortAlphaUpAlt : fonts.faSortAlphaUpAlt,
  faFireFlameCurved : fonts.faFireFlameCurved,
  faFireAlt : fonts.faFireAlt,
  faTornado : fonts.faTornado,
  faFileCirclePlus : fonts.faFileCirclePlus,
  faBookQuran : fonts.faBookQuran,
  faQuran : fonts.faQuran,
  faAnchor : fonts.faAnchor,
  faBorderAll : fonts.faBorderAll,
  faFaceAngry : fonts.faFaceAngry,
  faAngry : fonts.faAngry,
  faCookieBite : fonts.faCookieBite,
  faArrowTrendDown : fonts.faArrowTrendDown,
  faRss : fonts.faRss,
  faFeed : fonts.faFeed,
  faDrawPolygon : fonts.faDrawPolygon,
  faScaleBalanced : fonts.faScaleBalanced,
  faBalanceScale : fonts.faBalanceScale,
  faGaugeSimpleHigh : fonts.faGaugeSimpleHigh,
  faTachometer : fonts.faTachometer,
  faTachometerFast : fonts.faTachometerFast,
  faShower : fonts.faShower,
  faDesktop : fonts.faDesktop,
  faDesktopAlt : fonts.faDesktopAlt,
  faM : fonts.faM,
  faTableList : fonts.faTableList,
  faThList : fonts.faThList,
  faCommentSms : fonts.faCommentSms,
  faSms : fonts.faSms,
  faBook : fonts.faBook,
  faUserPlus : fonts.faUserPlus,
  faCheck : fonts.faCheck,
  faBatteryThreeQuarters : fonts.faBatteryThreeQuarters,
  faBattery4 : fonts.faBattery4,
  faHouseCircleCheck : fonts.faHouseCircleCheck,
  faAngleLeft : fonts.faAngleLeft,
  faDiagramSuccessor : fonts.faDiagramSuccessor,
  faTruckArrowRight : fonts.faTruckArrowRight,
  faArrowsSplitUpAndLeft : fonts.faArrowsSplitUpAndLeft,
  faHandFist : fonts.faHandFist,
  faFistRaised : fonts.faFistRaised,
  faCloudMoon : fonts.faCloudMoon,
  faBriefcase : fonts.faBriefcase,
  faPersonFalling : fonts.faPersonFalling,
  faImagePortrait : fonts.faImagePortrait,
  faPortrait : fonts.faPortrait,
  faUserTag : fonts.faUserTag,
  faRug : fonts.faRug,
  faEarthEurope : fonts.faEarthEurope,
  faGlobeEurope : fonts.faGlobeEurope,
  faCartFlatbedSuitcase : fonts.faCartFlatbedSuitcase,
  faLuggageCart : fonts.faLuggageCart,
  faRectangleXmark : fonts.faRectangleXmark,
  faRectangleTimes : fonts.faRectangleTimes,
  faTimesRectangle : fonts.faTimesRectangle,
  faWindowClose : fonts.faWindowClose,
  faBahtSign : fonts.faBahtSign,
  faBookOpen : fonts.faBookOpen,
  faBookJournalWhills : fonts.faBookJournalWhills,
  faJournalWhills : fonts.faJournalWhills,
  faHandcuffs : fonts.faHandcuffs,
  faTriangleExclamation : fonts.faTriangleExclamation,
  faExclamationTriangle : fonts.faExclamationTriangle,
  faWarning : fonts.faWarning,
  faDatabase : fonts.faDatabase,
  faShare : fonts.faShare,
  faMailForward : fonts.faMailForward,
  faBottleDroplet : fonts.faBottleDroplet,
  faMaskFace : fonts.faMaskFace,
  faHillRockslide : fonts.faHillRockslide,
  faRightLeft : fonts.faRightLeft,
  faExchangeAlt : fonts.faExchangeAlt,
  faPaperPlane : fonts.faPaperPlane,
  faRoadCircleExclamation : fonts.faRoadCircleExclamation,
  faDungeon : fonts.faDungeon,
  faAlignRight : fonts.faAlignRight,
  faMoneyBill1Wave : fonts.faMoneyBill1Wave,
  faMoneyBillWaveAlt : fonts.faMoneyBillWaveAlt,
  faLifeRing : fonts.faLifeRing,
  faHands : fonts.faHands,
  faSignLanguage : fonts.faSignLanguage,
  faSigning : fonts.faSigning,
  faCalendarDay : fonts.faCalendarDay,
  faWaterLadder : fonts.faWaterLadder,
  faLadderWater : fonts.faLadderWater,
  faSwimmingPool : fonts.faSwimmingPool,
  faArrowsUpDown : fonts.faArrowsUpDown,
  faArrowsV : fonts.faArrowsV,
  faFaceGrimace : fonts.faFaceGrimace,
  faGrimace : fonts.faGrimace,
  faWheelchairMove : fonts.faWheelchairMove,
  faWheelchairAlt : fonts.faWheelchairAlt,
  faTurnDown : fonts.faTurnDown,
  faLevelDownAlt : fonts.faLevelDownAlt,
  faPersonWalkingArrowRight : fonts.faPersonWalkingArrowRight,
  faSquareEnvelope : fonts.faSquareEnvelope,
  faEnvelopeSquare : fonts.faEnvelopeSquare,
  faDice : fonts.faDice,
  faBowlingBall : fonts.faBowlingBall,
  faBrain : fonts.faBrain,
  faBandage : fonts.faBandage,
  faBandAid : fonts.faBandAid,
  faCalendarMinus : fonts.faCalendarMinus,
  faCircleXmark : fonts.faCircleXmark,
  faTimesCircle : fonts.faTimesCircle,
  faXmarkCircle : fonts.faXmarkCircle,
  faGifts : fonts.faGifts,
  faHotel : fonts.faHotel,
  faEarthAsia : fonts.faEarthAsia,
  faGlobeAsia : fonts.faGlobeAsia,
  faIdCardClip : fonts.faIdCardClip,
  faIdCardAlt : fonts.faIdCardAlt,
  faMagnifyingGlassPlus : fonts.faMagnifyingGlassPlus,
  faSearchPlus : fonts.faSearchPlus,
  faThumbsUp : fonts.faThumbsUp,
  faUserClock : fonts.faUserClock,
  faHandDots : fonts.faHandDots,
  faAllergies : fonts.faAllergies,
  faFileInvoice : fonts.faFileInvoice,
  faWindowMinimize : fonts.faWindowMinimize,
  faMugSaucer : fonts.faMugSaucer,
  faCoffee : fonts.faCoffee,
  faBrush : fonts.faBrush,
  faMask : fonts.faMask,
  faMagnifyingGlassMinus : fonts.faMagnifyingGlassMinus,
  faSearchMinus : fonts.faSearchMinus,
  faRulerVertical : fonts.faRulerVertical,
  faUserLarge : fonts.faUserLarge,
  faUserAlt : fonts.faUserAlt,
  faTrainTram : fonts.faTrainTram,
  faUserNurse : fonts.faUserNurse,
  faSyringe : fonts.faSyringe,
  faCloudSun : fonts.faCloudSun,
  faStopwatch20 : fonts.faStopwatch20,
  faSquareFull : fonts.faSquareFull,
  faMagnet : fonts.faMagnet,
  faJar : fonts.faJar,
  faNoteSticky : fonts.faNoteSticky,
  faStickyNote : fonts.faStickyNote,
  faBugSlash : fonts.faBugSlash,
  faArrowUpFromWaterPump : fonts.faArrowUpFromWaterPump,
  faBone : fonts.faBone,
  faUserInjured : fonts.faUserInjured,
  faFaceSadTear : fonts.faFaceSadTear,
  faSadTear : fonts.faSadTear,
  faPlane : fonts.faPlane,
  faTentArrowsDown : fonts.faTentArrowsDown,
  faExclamation : fonts.faExclamation,
  faArrowsSpin : fonts.faArrowsSpin,
  faPrint : fonts.faPrint,
  faTurkishLiraSign : fonts.faTurkishLiraSign,
  faTry : fonts.faTry,
  faTurkishLira : fonts.faTurkishLira,
  faDollarSign : fonts.faDollarSign,
  faDollar : fonts.faDollar,
  faUsd : fonts.faUsd,
  faX : fonts.faX,
  faMagnifyingGlassDollar : fonts.faMagnifyingGlassDollar,
  faSearchDollar : fonts.faSearchDollar,
  faUsersGear : fonts.faUsersGear,
  faUsersCog : fonts.faUsersCog,
  faPersonMilitaryPointing : fonts.faPersonMilitaryPointing,
  faBuildingColumns : fonts.faBuildingColumns,
  faBank : fonts.faBank,
  faInstitution : fonts.faInstitution,
  faMuseum : fonts.faMuseum,
  faUniversity : fonts.faUniversity,
  faUmbrella : fonts.faUmbrella,
  faTrowel : fonts.faTrowel,
  faD : fonts.faD,
  faStapler : fonts.faStapler,
  faMasksTheater : fonts.faMasksTheater,
  faTheaterMasks : fonts.faTheaterMasks,
  faKipSign : fonts.faKipSign,
  faHandPointLeft : fonts.faHandPointLeft,
  faHandshakeSimple : fonts.faHandshakeSimple,
  faHandshakeAlt : fonts.faHandshakeAlt,
  faJetFighter : fonts.faJetFighter,
  faFighterJet : fonts.faFighterJet,
  faSquareShareNodes : fonts.faSquareShareNodes,
  faShareAltSquare : fonts.faShareAltSquare,
  faBarcode : fonts.faBarcode,
  faPlusMinus : fonts.faPlusMinus,
  faVideo : fonts.faVideo,
  faVideoCamera : fonts.faVideoCamera,
  faGraduationCap : fonts.faGraduationCap,
  faMortarBoard : fonts.faMortarBoard,
  faHandHoldingMedical : fonts.faHandHoldingMedical,
  faPersonCircleCheck : fonts.faPersonCircleCheck,
  faTurnUp : fonts.faTurnUp,
  faLevelUpAlt : fonts.faLevelUpAlt,
  }
}
